import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/bergler.webp';
import screenshot_target from '../../../images/letterfunnel/mennojongerius.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Menno Jongerius"
      firstname="Menno"
      companyname="Bergler"
      competition="Info Support en DPA IT"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/mennojongerius.js